import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"
import api from "../../../api";
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import {
    postFakeForgetPwd,
    postJwtForgetPwd,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

export const userForgetPassword = (user, history) => async (dispatch) => {
    try {
        // Access-Management hardening (Round 1): the identifier may be an
        // e-mail address OR an Emp ID, and the server always answers with the
        // same generic message (no account enumeration). We show that message.
        const identifier = (user.emailOrEmpId ?? user.email ?? "").trim();
        const response = await api.post("Auth/forgot-password", {
            emailOrEmpId: identifier,
            email: identifier, // legacy field name, still accepted by older API builds
        });

        if (response.status === 200) {
            dispatch(userForgetPasswordSuccess(
                response?.data?.message ||
                "If an eligible account matches the information provided, password reset instructions have been sent to the e-mail address on file."
            ));
        } else {
            dispatch(userForgetPasswordError("We could not process the request right now. Please try again."));
        }
    } catch (error) {
        const data = error?.response?.data;
        const msg = typeof data === "string" ? data : (data?.message || data?.error || "We could not process the request right now. Please try again.");
        dispatch(userForgetPasswordError(msg));
    }
}